/* eslint-disable no-nested-ternary */
import React, {Component} from 'react';

import PropTypes from 'prop-types';
// import {Button} from 'react-bootstrap';

import PopUpButtons from './PopUpButtons';
import StandalonePopUp from './StandalonePopUp';

// import * as APPDATA from 'ProteinConcentrator/ClientApp/AppData/PCConstAppData';
// import * as modalActions from 'ProteinConcentrator/ClientApp/Store/actions/modalActions';

class PopUp extends Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
  }

  close() {
    const {onClose} = this.props;
    onClose(onClose);
    // this.props.dispatch(modalActions.hidePopUp());
    // if (this.props.popUpClose !== undefined) {
    //   const e = {
    //     currentTarget: {
    //       id: APPDATA.CLOSE,
    //     },
    //   };
    //   this.props.popUpClose(e);
    // }
  }

  // generateButton() {
  //   const {popUpButton} = this.props;
  //   const button = popUpButton
  //     ? popUpButton.map((button) => {
  //         const classButton = button.isPrimaryButton
  //           ? `primaryButton no-outline ${button.className}`
  //           : button.className
  //           ? `${button.className} no-outline `
  //           : 'secondaryButton no-outline ';
  //         return (
  //           <Button
  //             id={button.id}
  //             key={button.id}
  //             bsSize="large"
  //             className={classButton}
  //             onClick={button.onClick}
  //             disabled={button.disabled}
  //           >
  //             {button.label.toUpperCase()}
  //           </Button>
  //         );
  //       })
  //     : '';
  //   return button;
  // }

  render() {
    const {popUpVisible, popUpTitle, popUpText, popUpQuestion, popUpHideCloseButton, popUpButton} = this.props;
    // const showYesNo = popUpButton === APPDATA.YESORNO;
    // const showOk = popUpButton === APPDATA.OK;
    // const showUpdateSaveAsDiscard = popUpButton === APPDATA.UPDATE_SAVE_AS_DISCARD;
    let id = 0;
    const showPopUpBody =
      typeof popUpText === 'string' ? (
        popUpText === '' ? null : (
          <div className="row popUptextdiv">
            <span className="popUpText">
              {popUpText.split('\n').map((item) => {
                id += 1;
                return (
                  <span key={id}>
                    {item}
                    <br />
                  </span>
                );
              })}
            </span>
          </div>
        )
      ) : (
        popUpText
      );
    const hidePopUpCloseButton = popUpHideCloseButton;

    return (
      <StandalonePopUp
        isPopUpVisible={popUpVisible}
        contents={{
          popUpTitle,
          popUpBody: (
            <div>
              {showPopUpBody}
              {popUpQuestion && (
                <div className="row popUpQuestion">
                  <span className="popUpQuestionText">{popUpQuestion}</span>
                </div>
              )}
            </div>
          ),
          popUpFooter: (
            <div className="row">
              <div className="buttondiv">
                <PopUpButtons data={popUpButton} />
              </div>
            </div>
          ),
        }}
        onClose={this.close}
        hideCloseButton={hidePopUpCloseButton}
      />
    );
  }
}

PopUp.propTypes = {
  popUpButton: PropTypes.array,
  popUpVisible: PropTypes.bool,
  popUpTitle: PropTypes.string,
  popUpText: PropTypes.any,
  popUpQuestion: PropTypes.string,
  popUpHideCloseButton: PropTypes.bool,
  onClose: PropTypes.func,
};

PopUp.defaultProps = {
  popUpButton: [],
  popUpVisible: false,
  popUpTitle: '',
  popUpText: '',
  popUpQuestion: '',
  popUpHideCloseButton: false,
  onClose: () => {},
};

export default PopUp;
